import { Button, FormControl, FormLabel, Modal, TextField } from "@mui/material";
import { FunctionComponent } from "react";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import { SelectSede } from "../../../../components/selects/sede";


export const GrupoMinisterioAdd: FunctionComponent = () => {

  const {
    goBack,
  } = useNav();

  const {
    register,
    watch,
    setValue
  } = useForm<{ sede: number, descricao: string }>({
    defaultValues: {
      sede: null,
      descricao: null
    }
  })

  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal>
          <SelectSede action={(action) => setValue('sede', action)} value={watch('sede')} />

          <FormControl sx={{ mt: 1 }} fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained">Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}
